<template>

  <v-card class="admincontent">

    <v-card-title
      class="stickysub"
      >
      Testfelder
      <v-btn 
        icon
        class="ml-4"
        :to="'/'+$home+'node/add/'+ct"
        title="Testfeld hinzufügen"
        >
        <v-icon>mdi-plus-circle-outline</v-icon>
      </v-btn>          
    <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Suchen"
        single-line
        hide-details
        class="pt-0"
      ></v-text-field>
    </v-card-title>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="testfields"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50]
      }"
      :items-per-page="30"
      :single-select="singleSelect"
      :search="search"
      item-key="id"
      class="elevation-1"
    >

    <template v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="(item,index) in items"
                :key="item.id"
              >
                <td>{{ item.id }}</td>
                <td>
                  <v-icon 
                    size="18" 
                    v-if="item.published == true"
                    color="green"
                    >mdi-check</v-icon>
                  <v-icon 
                    size="18" 
                    v-if="item.published == false"
                    color="red"
                    >mdi-eye-off-outline</v-icon>                  
                </td>
                <td>
                  <router-link :to="'/'+$home+'node/field/' + item.id" text small>
                  {{ item.title }}
                  </router-link>
                </td>
                <td v-html="item.preview" class="p"></td>
                <td v-html="item.usecases" class="p"></td>
                <td v-html="item.resp_name" class="p"></td>
                <td>
                  <v-btn :to="'/'+$home+'p/field/' + item.id" class="" text small target="_blank">
                    <v-icon size="18" >mdi-open-in-new</v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-btn :to="'/node/field/' + item.id" class="" text small>
                    <v-icon size="18" >mdi-pencil</v-icon>
                  </v-btn>                  
                  <v-btn @click="deleteTf(index,item.id)" class="" text small>
                    <v-icon size="18" >mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>

    <!--
    <template v-slot:top>
      <v-switch v-model="singleSelect" label="Single select" class="pa-3"></v-switch>
    </template>
    -->


    </v-data-table>

  </v-card>
</template>

<script>
export default {
  name: 'AdminTestFields',
  props: ['ct'],
  data () {
    return {
      singleSelect: false,
      selected: [],
      search: '',
      headers: [
        { text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'veröffentl.',
          value: 'published'
        },
        {
          text: 'Name',
          value: 'title',
        },
        {
          text: 'Beschreibung',
          value: 'description'
        },
        {
          text: 'Usecases',
          value: 'usecases'
        },
        {
          text: 'verantwortlich',
          value: 'responsible_id'
        },
        {
          text: 'Vorschau'
        },
        {
          text: ''
        }
      ],
      testfields: [],
      overlaydata: null
    }
  },
  methods: {
      getTestfields() {
          console.log("Fkt getTestfields");
          this.axios.get( this.$config.host+"/testfields" ).then(response => (
            this.testfields = response.data,
            console.log(this.testfields)
          ));
      },
      deleteTf(index, id) {
          if(confirm('Soll der Datensatz wirklich gelöscht werden?')) {
            console.log("Fkt deleteTestfield");
            this.axios.post( this.$config.host+"/field/delete/"+id ).then(response => (
              console.log(response),
              this.removeIndex(index)
            ));
          }
      },
      removeIndex(index) {
          this.$delete(this.testfields, index)
      }
  },
  mounted() {

    this.getTestfields();

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  margin:0 0 40px 0;
  padding: 40px;
  background-color:#f5f5f5;
}
.item {
  display:block;
  width:100%;
  background-color:lightblue;
  margin-bottom:4px;
}
.p >>> p {
  margin:0;
}
a {
  color: #42b983;
}
</style>
